import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LoginUser, reset, getMe } from "../features/authSlice";
import { Button, Label, TextInput } from "flowbite-react";
import { BsPersonCircle } from "react-icons/bs";
import logo from "../logo.png";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, isError, isSuccess, isLoading, message } = useSelector(
    (state) => state.auth
  );

  useEffect(() => {
    if (!sessionStorage.getItem("reloaded")) {
      sessionStorage.setItem("reloaded", "true");
      window.location.reload(true);
    }
  }, []);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (user || isSuccess) {
      navigate("/home");
    }
    dispatch(reset());
  }, [user, isSuccess, dispatch, navigate]);

  const Auth = (e) => {
    e.preventDefault();
    dispatch(LoginUser({ username, password }));
  };

  return (
    <div
      style={{
        backgroundImage: `linear-gradient(to top, #4481eb 0%, #04befe 100%)`,
      }}
      className="fixed inset-0 bg-black bg-opacity-25 backdrop-blur-sm flex flex-col justify-center items-center"
    >
      <div className="relative max-w-2xl w-[24rem] rounded-lg flex flex-col items-center shadow-lg pt-12 px-8 pb-10 bg-white">
        {/* Floating Logo + Icon */}
        <div className="absolute -top-32 flex flex-col items-center">
          <div className=" p-3  ">
            <img src={logo} alt="Logo" width={150} height={150} />
          </div>
          <BsPersonCircle className="text-sky-600 text-7xl mt-2 bg-white rounded-full border shadow-md" />
        </div>

        {/* Form */}
        <form onSubmit={Auth} className="flex flex-col gap-4 w-full">
          {isError && (
            <p className="text-red-600 text-sm text-center">{message}</p>
          )}

          <div>
            <div className="mb-2 block">
              <Label htmlFor="emailUser" value="Username" />
            </div>
            <TextInput
              id="emailUser"
              name="emailUser"
              placeholder="Username"
              required
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          <div>
            <div className="mb-2 block">
              <Label htmlFor="password_user" value="Your password" />
            </div>
            <TextInput
              name="password_user"
              id="password_user"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <Button type="submit">{isLoading ? "Loading..." : "Login"}</Button>
        </form>
      </div>
    </div>
  );
};

export default Login;
